var map = {
	"./LeftLogoKural.svg": [
		93750,
		[
			750
		]
	],
	"./LeftLogoLily.svg": [
		87393,
		[
			393
		]
	],
	"./LeftLogoPXB.svg": [
		52153,
		[
			153
		]
	],
	"./LeftLogoPXBD.svg": [
		38379,
		[
			379
		]
	],
	"./LeftLogoPXB_SNFI.svg": [
		45340,
		[
			340
		]
	],
	"./LeftLogoQualAI_Kural.svg": [
		2866,
		[
			866
		]
	],
	"./LeftLogoSNFI.svg": [
		98265,
		[
			265
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96115;
module.exports = webpackAsyncContext;